import React from 'react';

const ExportContext = React.createContext('exports');

export default ExportContext;
